import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import '@/assets/tailwind.css'; 
import "../node_modules/typeface-fira-code";

createApp(App).use(router).mount('#app');
